<template>
  <button
    class="button"
    :class="[
      `button-${type}`,
      {'button--icon' : iconName.length},
      {'button--full' : full},
    ]"
    :disabled="disable"
  >
    <div
      :style="{color: iconColor}"
      :class="[`button-${type}-icon`]"
    >
      <template v-if="iconName.length">
        <!-- <icon-base class="icon" icon-name="moon">
              <component :is="componentFile"/>
            </icon-base> -->
      </template>
    </div>
    <div class="button__text">
      <slot />
    </div>
  </button>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ApButton',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    iconName: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit('click');
    };
    return {
      onClick,
    };
  },
});
</script>
<style lang="scss" scoped>

    .button{
      appearance: none;
      border: 0;
      border-radius: 0;
      min-width: 100px;
      font-family: inherit;
      cursor: pointer;
      display: inline-block;
      border-radius: 6px;
      min-width: 100px;
      padding: 10px 16px;
      font-weight: 500;
      font-size: 14px;
      font-family: inherit;
      &--icon{
          display: flex;
          align-items: center;
          align-content: space-around;
          justify-content: left;
      }
      &--full{
          width: 100%;
          justify-content: center;
      }
    }
  
      .button-primary {
        background: $primary-purple;
        border: 1px solid $primary-purple;
        border-radius: 8px;
        padding: 11px 16px;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        
        .button__text{
          color: #FFFFFF;
        }

        &[disabled] {
          pointer-events: none;
          background: $primary-gray;
          border: 1px solid $primary-gray;
        }
      }
      .button-secondary{
        background-color: #FFFFFF;
        color: #FF564B;
      }
      .button-tertiary{
        background-color: #FFFFFF;
        border: 2px solid #FF564B;
        color: #0E243A;
        .button-tertiary-icon {
          color: #FF564B;
        }
        &:hover
        &:focus {
          color: #FFFFFF !important;
          background-color: #FF564B;
          .button-tertiary-icon{
              color: #FFFFFF;
          }
        }
      }
      .button-quaternary {
        background: #3696E6;
        border: 1px solid #3696E6;
        color: #FFFFFF;
        
        &:hover {
          background: #2B8BE4;
        }
        &:active
        &:focus {
          background-color: #2B8BE4;
        }
        &[disabled] {
          opacity: 0.5;
          pointer-events: none;
        }
      }
   .default{}       
   .tele2{
    .button{
      &__text{
        font-size: 13px; 
        text-transform: uppercase;
         *{
            font-weight: 700;
            line-height: 16px;
         }
       }
     }
      .button-primary {
        background: black;
        border: 1px solid black;
        border-radius: 24px;
        font-weight: 700;
        font-size: 13px;
        line-height: 16px;
        padding: 16px;

        &[disabled] {
          pointer-events: none;
          background: $primary-gray;
          border: 1px solid $primary-gray;
        }
      }
   }
   .altel{
     .button{
       &__text{
         font-weight: 500;
          font-size: 20px;
          line-height: 16px;
          text-align: center;
          text-transform: capitalize;
       }
     }
     .button-primary {
        background: $primary-pink;
        border: 1px solid $primary-pink;
        border-radius: 4px;
        font-weight: 700;
        font-size: 13px;
        line-height: 16px;
        padding: 16px;

        &[disabled] {
          pointer-events: none;
          opacity: 0.5;
        }
      }
   }
</style>